import { initialModelCategoryState } from './initialState';

import { MODEL_CATEGORY_ACTION_TYPES } from '../constants/index';

const modelCategoryReducer = (state = initialModelCategoryState, action) => {
  const { payload, type } = action;
  switch (type) {
    case MODEL_CATEGORY_ACTION_TYPES.GET_ALL_MODELCATEGORY_DETAILS: {
      const { data } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          ...data
        }
      };
    }
    case MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_CURRENT_PAGE: {
      const { currentPage } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          currentPage
        }
      };
    }
    case MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_PAGE_FILTER: {
      const { filter } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          filter
        }
      };
    }
    case MODEL_CATEGORY_ACTION_TYPES.UPDATE_MODELCATEGORY_USER_SAVE_STATUS: {
      const { data } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          ...data
        }
      };
    }
    case MODEL_CATEGORY_ACTION_TYPES.MODELCATEGORY_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          isLoading
        }
      };
    }
    case MODEL_CATEGORY_ACTION_TYPES.MODELCATEGORY_ERROR: {
      const { data } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          ...data
        }
      };
    }

    case MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_DETAILS: {

      let { modelCategoryTypes, modelCategoryDetails } = payload;
      let modelCategoryData = modelCategoryDetails || {};
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          modelCategoryTypes:modelCategoryTypes,
          selectedModelCategory: {
            ...state.modelCategoryManager.selectedModelCategory,
            ...modelCategoryData
          }
        },
        isLoading: false,
        showBanner: false,
        isOpSuccessful: true
      };
    }
    case MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_CHANGE: {
      let { selectedModelCategory } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          selectedModelCategory
        },
        isLoading: false,
        showBanner: false,
        isOpSuccessful: true
      };
    }
    case MODEL_CATEGORY_ACTION_TYPES.SET_MODELCATEGORY_FILTERED_RESULTS: {
      const { filteredResults } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          ...filteredResults
        }
      };
    }
    case MODEL_CATEGORY_ACTION_TYPES.MODELCATEGORY_CLEANUP: {
      const { data } = payload;
      return {
        ...state,
        modelCategoryManager: {
          ...state.modelCategoryManager,
          ...data.modelCategoryManager
        }
      };
    }
    default:
      return state;
  }
};

export default modelCategoryReducer;